import { isGlobalFeatureEnabled } from "owa-feature-flags";

export const useIsTypeRampUpdatesEnabled = (): boolean => isGlobalFeatureEnabled("mon-type-ramp");
